import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const excelExport = (columns, data, datosColumnas ,fileName = "tabla.xlsx") => {
    if (!data.length) {
        alert("No hay datos para exportar");
        return;
    }
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Mes empieza en 0
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    // Formato YYYYMMDD_HHmmss
    const timestamp = `${year}${month}${day}_${hours}${minutes}${seconds}`;
    const nombreArchivo = `${fileName}_${timestamp}.xlsx`;

    // Extraer nombres de las columnas dinámicamente
    const headers = columns.map(col => col.name);
    const formattedData = data.map(row => {
        const rowData = {};
        columns.forEach(col => {
            const columnName = col.name; // Ejemplo: "J 13"
            if (columnName === "Nombre") {
                rowData[columnName] = row.NombreCompleto || "";
            } else if (columnName === "Rut") {
                rowData[columnName] = row.Rut || "";
            } else {
                //obtener fecha
                console.log('recorriendo loop')
                console.log(columnName)
                console.log(JSON.stringify(row[columnName]))
                const datoCol = datosColumnas.find(p => p.FechaDia === columnName)
                const asistencia = row[datoCol.Fecha]?.Asistencia?.Presente;
                rowData[columnName] = asistencia === 1 ? "✅" : "❌";
            }
        });
        return rowData;
    });
    const worksheet = XLSX.utils.json_to_sheet(formattedData, { header: headers });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, nombreArchivo);
};
export const excelExportAsistencia = (columns, data,datosColumnas,name) => {
    if (!data.length) {
        alert("No hay datos para exportar");
        return;
    }

    // 🔹 Generar timestamp local en formato YYYYMMDD_HHmmss
    const now = new Date();
    const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}_${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;

    const fileName = `${name}_${timestamp}.xlsx`;

    // 🔹 Obtener los nombres de las columnas
    const headers = columns.map(col => col.name);

    // 🔹 Transformar datos en un formato plano para Excel
    const formattedData = data.map(row => {
        const rowData = {};
        
        columns.forEach(col => {
            const columnName = col.name; // Ejemplo: "J 13"
            
            if (columnName === "Nombre") {
                rowData[columnName] = row.NombreCompleto || "";
            } else if (columnName === "Rut") {
                rowData[columnName] = row.Rut || "";
            } else {
                const datoCol = datosColumnas.find(p => p.dayNumber === columnName)
                console.log(JSON.stringify(row[datoCol.Fecha]))
                //const asistencia = row[datoCol.Fecha]?.Asistencia;
                var valores=row[datoCol.Fecha];
                if(valores!= undefined && valores?.length>0){
                    console.log(valores[0].Sigla)
                    rowData[columnName] = valores.map(obj => obj.Sigla).join(',');//valores[0]?.Sigla
                    
                }
            }
        });

        return rowData;
    });

    // 🔹 Crear hoja de Excel
    const worksheet = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    // 🔹 Crear libro y agregar la hoja
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

    // 🔹 Generar y descargar archivo
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(dataBlob, fileName);
};
